import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex justify-end lg:justify-between items-center overflow-hidden w-full bg-wrh-blue-400 h-47 rounded-xl lg:pl-12" }
const _hoisted_2 = { class: "flex-1 lg:flex flex-col justify-center items-start hidden" }
const _hoisted_3 = { class: "t-32m text-white" }
const _hoisted_4 = { class: "flex items-center justify-end flex-shrink-0 space-x-0 md:space-x-6 w-full lg:w-auto" }

import {
  computed, PropType, toRef,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  home: {
    type: Object as PropType<any>,
  },
  user: {
    type: Object as PropType<any | null>,
  },
},
  setup(__props) {

const props = __props


const user = toRef(props, 'user') as any;
const home = toRef(props, 'home') as any;

const name = computed(() => user.value?.displayName?.split(' ')?.[0] || 'Jane');
const greeting = computed(() => {
  if (name.value) {
    return `Welcome back, ${name.value}!`;
  }
  return 'Welcome back!';
});

const welcomeMsg = 'Here’s what’s happening with your home today';
const coverUrl = '/images/home_cover_default.png';
const streetAddress = '12149 Fall Creek Court';
const metro = 'Hudson, FL 34669';
const community = 'Pine Ridge Community';
const plan = 'Saratoga Plan';
const elevation = '1425 sq ft., Elevation B';
const lot = 'Lot Number 0001';

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(greeting)), 1),
      _createElementVNode("p", { class: "t-16m text-white mt-2" }, _toDisplayString(welcomeMsg))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("address", { class: "md:flex flex-col items-end justify-center space-y-1 hidden" }, [
        _createElementVNode("span", { class: "t-14r text-wrh-blue-100 capitalize" }, _toDisplayString(streetAddress)),
        _createElementVNode("span", { class: "t-14r text-wrh-blue-100 capitalize" }, _toDisplayString(metro)),
        _createElementVNode("span", { class: "t-14r text-wrh-blue-100 capitalize" }, _toDisplayString(community)),
        _createElementVNode("span", { class: "t-14r text-wrh-blue-100 capitalize" }, _toDisplayString(plan)),
        _createElementVNode("span", { class: "t-14r text-wrh-blue-100 capitalize" }, _toDisplayString(elevation)),
        _createElementVNode("span", { class: "t-14r text-wrh-blue-100 capitalize" }, _toDisplayString(lot))
      ]),
      coverUrl
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: coverUrl,
            alt: streetAddress,
            class: "w-full md:w-82 flex-shrink-0 object-cover object-center rounded-xl md:rounded-l-none md:rounded-r-xl"
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})